function setEqualHeightToSlides(slides) {
  if (!slides || slides.length === 0) return;

  let maxHeight = 0;
  slides.forEach(slide => {
    slide.style.height = 'auto';
    const slideHeight = slide.offsetHeight;
    if (slideHeight > maxHeight) {
      maxHeight = slideHeight;
    }
  });

  slides.forEach(slide => {
    slide.style.height = `${maxHeight}px`;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const slides = document.querySelectorAll('.PF-testimonials .flickity-slider .slide-item');
  const updateSlidesHeight = () => setEqualHeightToSlides(slides);

  setTimeout(updateSlidesHeight, 100);

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateSlidesHeight, 200);
  });
});
